import { render, staticRenderFns } from "./kalender.vue?vue&type=template&id=74adb6b1&scoped=true&"
import script from "./kalender.vue?vue&type=script&lang=js&"
export * from "./kalender.vue?vue&type=script&lang=js&"
import style0 from "./kalender.vue?vue&type=style&index=0&id=74adb6b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74adb6b1",
  null
  
)

export default component.exports